import type { FindChangedFormsOptions } from '@typeDefinitions/changeTrackingTypes';

import { findChangedFieldPaths } from './findChangedFields';

export const findChangedForms = <TForm extends string>(
  before: unknown,
  after: unknown,
  options: FindChangedFormsOptions<TForm>,
): TForm[] => {
  const { getForm, ...diffOptions } = options;
  const forms = findChangedFieldPaths(before, after, diffOptions)
    .map(getForm)
    .filter((form): form is TForm => form !== undefined && form !== '');

  return [...new Set(forms)].sort((left, right) => left.localeCompare(right));
};
